import React, { useState, useEffect } from 'react';
import { Modal, Button, Row, Col, Nav } from 'react-bootstrap';
import './CommonGuideModal.scss';

const CommonGuideModal = ({ show, onHide, title, tabs }) => {
  const [activeTab, setActiveTab] = useState('');
  const [zoomedImage, setZoomedImage] = useState(null);

  // Synchronize activeTab with the first tab when tabs data loads or changes
  useEffect(() => {
    if (tabs && tabs.length > 0) {
      setActiveTab(tabs[0].id);
    }
  }, [tabs]);

  const currentTab = tabs?.find(t => t.id === activeTab) || tabs?.[0];

  const renderPlaceholder = (tabLabel, stepNum) => {
    return (
      <div className="mg-placeholder-card">
        <div className="mg-placeholder-icon">📸</div>
        <div className="mg-placeholder-title">Screenshot Placeholder</div>
        <div className="mg-placeholder-subtitle">
          {tabLabel} - Step {stepNum}
        </div>
        <div className="mg-placeholder-hint">Visual guide will be uploaded here</div>
      </div>
    );
  };

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        size="xl"
        centered
        scrollable
        dialogClassName="mg-guide-modal"
      >
        <Modal.Header closeButton className="mg-guide-header">
          <Modal.Title className="mg-guide-title">
            <span className="mg-guide-icon">📖</span> {title || 'User Guide & Tutorial'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="mg-guide-body">
          {tabs && tabs.length > 1 && (
            <Nav variant="pills" className="mg-guide-tabs mb-4 justify-content-center">
              {tabs.map(tab => (
                <Nav.Item key={tab.id}>
                  <Nav.Link
                    active={activeTab === tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className="mg-guide-tab-link"
                  >
                    {tab.label}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          )}

          {currentTab && (
            <div className="mg-steps-container">
              <div className="text-center mb-5">
                <h4 className="mg-tab-title">{currentTab.title}</h4>
                {currentTab.subtitle && (
                  <p className="mg-tab-subtitle">{currentTab.subtitle}</p>
                )}
              </div>

              {currentTab.steps?.map((step) => {
                const usePlaceholder = step.isPlaceholder || !step.image;
                return (
                  <Row key={step.number} className="mg-step-row align-items-center mb-5">
                    <Col lg={5} className="mg-guide-text-section mb-4 mb-lg-0">
                      <div className="mg-step-card">
                        <div className="mg-step-badge-wrapper">
                          <span className={`mg-step-badge ${activeTab !== tabs?.[0]?.id ? 'secondary' : ''}`}>
                            {step.number}
                          </span>
                          <h5 className="mg-step-title">{step.title}</h5>
                        </div>
                        <p className="mg-step-desc mt-3 whitespace-pre-line">{step.description}</p>
                      </div>
                    </Col>
                    <Col lg={7} className="mg-guide-image-section">
                      {usePlaceholder ? (
                        <div className="mg-image-frame placeholder-mode">
                          {renderPlaceholder(currentTab.title, step.number)}
                        </div>
                      ) : (
                        <div className="mg-image-frame" onClick={() => setZoomedImage(step.image)}>
                          <img
                            src={step.image}
                            alt={step.title}
                            className="img-fluid rounded shadow-sm mg-guide-step-img"
                          />
                          <div className="mg-image-zoom-overlay">
                            <span className="mg-zoom-icon">🔍 Click to zoom</span>
                          </div>
                        </div>
                      )}
                    </Col>
                  </Row>
                );
              })}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="mg-guide-footer">
          <Button variant="secondary" onClick={onHide} className="mg-guide-close-btn">
            Got It, Thanks!
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Lightbox / Zoom Image Modal */}
      <Modal
        show={!!zoomedImage}
        onHide={() => setZoomedImage(null)}
        size="xl"
        centered
        dialogClassName="mg-lightbox-modal"
      >
        <Modal.Body className="p-0 bg-transparent text-center position-relative">
          <button className="mg-lightbox-close" onClick={() => setZoomedImage(null)}>×</button>
          {zoomedImage && (
            <img
              src={zoomedImage}
              alt="Zoomed Step Screenshot"
              className="img-fluid rounded mg-lightbox-img"
              onClick={() => setZoomedImage(null)}
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CommonGuideModal;
